import { Box, Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import { useSelector } from "react-redux";
import { assetTypeMap } from "../leases/components/LeaseConstants";

const BackToLeaseList = () => {
    const { leaseBasicDetails } = useSelector((state) => state.leases);
    const assetNavLink = (leaseBasicDetails?.asset?.asset_type && leaseBasicDetails?.asset?.slug) ? `/assets/${leaseBasicDetails?.asset?.asset_type}/${assetTypeMap[leaseBasicDetails?.asset?.asset_type]}/${leaseBasicDetails?.asset?.slug}/leases` : null;

    return (
        <Box className="lease-list-title" sx={{ marginBottom: "3px" }}>
            <Link
                component={RouterLink}
                to={assetNavLink ? assetNavLink :  `/leases` }
                sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    fontFamily: "Roboto",
                    textDecoration: "none",
                    cursor: "pointer",
                    marginLeft: "-2px",
                    width: "fit-content"
                }}
            >
                <ArrowCircleLeftOutlinedIcon />
                <Typography
                    sx={{
                        fontSize: "13px",
                        fontWeight: "bold",
                        paddingLeft: "5px",
                        textDecoration: "underline"
                    }}
                >
                    Lease List
                </Typography>
            </Link>
        </Box>
    );
};

export default BackToLeaseList;